import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { BackArrowIcon } from '../../../constants/icon-constants';
import LightHistoryIcon from '../../../assets/images/LIGHT_HISTORY.svg';
import DarkHistoryIcon from '../../../assets/images/DARK_HISTORY.svg';
import styles from './header.module.scss';

const Header = ({ icon, componentIcon, iconLabel, title, onClickBack, onClickHistory }) => {
  const dark = useSelector((state) => state.basic.dark);
  return (
    <>
      <div className={cn(styles.header, { [styles.dark]: dark })}>
        <div className={styles.headerButtonContainer}>
          {onClickBack && (
            <Button className={styles.backButton} onClick={onClickBack}>
              {BackArrowIcon}
            </Button>
          )}
        </div>
        <div className={styles.headerTitleContainer}>
          <div className={styles.headerTokenContainer}>
            {icon && <img className={styles.headerToken} src={icon} alt='' />}
            {componentIcon && componentIcon}
            {iconLabel && <div className={styles.headerTokenLabel}>{iconLabel}</div>}
          </div>
          <span className={styles.headerTitle}>{title}</span>
        </div>
        <div className={styles.headerButtonContainer}>
          {onClickHistory && (
            <Button onClick={onClickHistory} className={styles.backButton}>
              <img src={dark ? DarkHistoryIcon : LightHistoryIcon} alt='' />
            </Button>
          )}
        </div>
        <div />
      </div>
      <div className={styles.divider} />
    </>
  );
};

Header.propTypes = {
  icon: PropTypes.string,
  iconLabel: PropTypes.string,
  title: PropTypes.string.isRequired,
  onClickBack: PropTypes.func,
  onClickHistory: PropTypes.func,
};

Header.defaultProps = {
  icon: null,
  iconLabel: '',
  onClickBack: null,
  onClickHistory: null,
};

export default Header;
